import { render, staticRenderFns } from "./RouteDefinitionListPage.vue?vue&type=template&id=2f2b15df&"
import script from "./_RouteDefinitionListPage.js?vue&type=script&lang=js&"
export * from "./_RouteDefinitionListPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports